import 'react-app-polyfill/ie9'
// 添加所需的 polyfill 在下面
import 'core-js/modules/es6.string.includes'
import 'core-js/modules/es6.string.repeat'
import 'core-js/modules/es6.string.starts-with'
import 'core-js/modules/es6.array.find'
import 'core-js/modules/es7.promise.finally'

import React from 'react'
import ReactDOM from 'react-dom'
import '-/styles/global.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
